export default "__VITE_ASSET__fz6kNwVg__"